<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <!-- dialog common header -->
    <popup-header v-on:clickClose="closeModal()"></popup-header>

    <v-row class="ma-0 overflow-y-auto">
      <v-col cols="12" class="py-0 notice">
        <!-- 게시글 헤더 -->
        <div class="notice-header">
          <p class="notice-title">{{ searchData.title }}</p>
          <p class="sub-desc">
            <span class="date">{{ createDateFormat }}</span>
            <span class="divider writer">{{ searchData.createUserName }}</span>
            <span class="divider cnt">
              <v-icon color="#cacdcf" size="15">mdi-eye</v-icon>
              {{ searchData.viewCount }}
            </span>
          </p>
        </div>

        <!-- 첨부파일 영역 -->
        <div class="notice-file">
          <span class="label">첨부파일</span>
          <span class="cnt">{{ fileList.length }}</span>
          <span class="volume">({{ totalFileSize }})</span>
          <span class="btn-save" @click="confirmFileAllDownload()"
            >모두저장</span
          >
          <v-list flat class="add-box-list" v-show="showFileFlag">
            <v-list-item-group>
              <v-list-item
                v-for="file in fileList"
                :key="file.seqNo"
                class="px-4"
                @click="downloadFile(file)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <file-img-icon v-bind:fileType="file.fileExt" />
                    <span v-text="file.fileName"></span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon color="#363c43" size="20">mdi-tray-arrow-down</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>

        <!-- 게시글 내용 -->
        <div class="notice-body" v-html="searchData.content"></div>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
/* 공지사항상세 모달 */
import PopupHeader from '@/components/common/PopupHeader.vue';
import FileImgIcon from '@/components/common/FileImgIcon.vue';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **
import { callApp } from '@/utils/app/callApp.js';
import { getBoardDetail } from '@/api/board';
import { downloadFile } from '@/api/file';
import { getDate } from '@/utils/common/dateUtil';

export default {
  mixins: [dialogMixin],

  props: {
    postId: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    modalName: 'board_detail',
    searchData: {},

    totalFileSize: 0,
    fileList: [],
  }),
  watch: {
    postId() {
      // 공통 스피너 ON
      this.$store.commit('SPINNER/ON_COMMON_SPINNER');

      this.fetchBoardDetail(); // 상세조회
    },
  },
  computed: {
    createDateFormat() {
      return getDate(this.searchData.createDate);
    },
    showFileFlag() {
      return this.searchData.fileId != null && this.fileList.length > 0
        ? true
        : false;
    },
  },
  methods: {
    /* 파일 사이즈 포맷 */
    formatBytes(bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
        dm = decimals || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },

    /* 첨부파일 전체다운로드 */
    confirmFileAllDownload() {
      if (!this.showFileFlag) {
        alert('첨부된 파일이 없습니다.');
        return;
      }

      if (confirm('첨부된 파일을 모두 저장하시겠습니까?')) {
        this.fileList.forEach(file => {
          this.downloadFile(file);
        });
      }
    },

    /* 첨부파일 다운로드 */
    async downloadFile(file) {
      try {
        const response = await downloadFile(file);
        const fileData = response.data;
        callApp.downloadFile({ dataUrl: fileData, fileName: file.fileName });
      } catch (error) {
        alert(error);
      }
    },

    /* 공지사항 상세조회 */
    async fetchBoardDetail() {
      // 초기화
      this.searchData = {};
      this.fileList = [];
      this.totalFileSize = 0;

      try {
        const response = await getBoardDetail({ postId: this.postId }); // 공지사항 상세조회 api호출

        if (response.data.data != null) {
          this.searchData = response.data.data;

          // 첨부파일이 있는 경우
          if (
            this.searchData.fileId != null &&
            this.searchData.fileList != []
          ) {
            this.fileList = this.searchData.fileList;

            let fileSize = 0;
            this.fileList.forEach(file => {
              fileSize += file.fileSize;
            });
            this.totalFileSize = this.formatBytes(fileSize);
          }
        }

        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },
  },
  components: {
    PopupHeader,
    FileImgIcon,
  },
};
</script>
